import React from "react";
import SMACDashboard from "./index";
import {VIEW_BY_REGISTRATION} from "./constants";


export default function DashboardRegistrationInstance() {
    return <SMACDashboard title="SMAC Registration" fixedTabValue={VIEW_BY_REGISTRATION}/>
}